export default "__VITE_ASSET__ChCcUc7x__"